import styles from './ReturnLink.module.css';

export function ReturnLink() {
  return (
    <a href="https://hypneuronerd.ing/" className={styles.link}>
      ← return to the gallery
    </a>
  );
}
